import React from 'react'; 
import {Link} from 'react-router-dom' 

function AnalisisCaminosCadaPaisPrevew(props) { 
    return ( 
        <div>
            <div> 
            <h1>Análisis de caminos desde cada país hacia el resto de la región
                    </h1>
                    <p>Autor: Elisa Peirano, I+D, LACNIC</p>

                    <p>Coordinación: Guillermo Cicileo, LACNIC</p>

                    <p>Área: I+D LACNIC</p>

                    <p>Fecha: 15/09/2025</p>
                    <Link className="buttons button_blue" to="/es/interconexion/analisis-de-caminos-desde-cada-pais-hacia-el-resto-de-la-region">Leer Reporte</Link>
                 
           
            </div> 
        </div>  
    );
}

export default AnalisisCaminosCadaPaisPrevew;

